module.exports = __webpack_public_path__ + "app/core/bo-user/bo-user-details-1jdD3_DQ.html";